export default __webpack_public_path__ + "static/media/location_preview_cafe.dc6b43a5.svg";